import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.surfaceCatalog.query.gql"
import { CAPABILITY_FEATURE_TYPE_CODE } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.compose.constants"
import { useFeatureGroupLens } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.lens.context"
import { lensedCatalog } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.lens.utils"
import type {
  FeatureSurfaceCatalogQuery,
  FeatureSurfaceCatalogQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/compose/__types__/license.featureGroup.surfaceCatalog.query"

type Options = QueryHookOptions<
  FeatureSurfaceCatalogQuery,
  FeatureSurfaceCatalogQueryVariables
>

/**
 * The capability catalog as the current lens sees it (see the content
 * catalog's hook). Every surface is of the capabilities' one feature type.
 */
export function useFeatureSurfaceCatalogQuery(options?: Options) {
  const result = useQuery<
    FeatureSurfaceCatalogQuery,
    FeatureSurfaceCatalogQueryVariables
  >(query, options)
  const lens = useFeatureGroupLens()
  const through = (data: FeatureSurfaceCatalogQuery | undefined) =>
    data && {
      getFeatureSurfaceCatalog: lensedCatalog(
        data.getFeatureSurfaceCatalog,
        lens,
        CAPABILITY_FEATURE_TYPE_CODE,
      ),
    }
  return {
    ...result,
    data: through(result.data),
    previousData: through(result.previousData),
  }
}
